import React, { Component } from "react";
import axios from "axios";
import { Grid, Row, Col } from "react-bootstrap";
import LoadingSpinner from "../components/Input/LoadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import HmacSHA256 from "crypto-js/hmac-sha256";
import ReactTable from "react-table";

class PickUpListe extends Component {
  state = {
    NrPod: "",
    nrKodi: "",
    AgjensiaBurim: "",
    PerdoruesId: "",
    IdProcesori: "",
    loading: false,
    alert: null,
    username: window.UserP.username,
    posts: [],
    posts1: [],
    errors: []
  };

  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value.toUpperCase() });

    if (name == "nrKodi")
    {
      this.setState({ NrPod: value.toUpperCase() });
    }
  };

  hideAlert() {
 
    this.setState({
      alert: null,
    });
  }

  showErrors() {
    const getAlert = () => (
      <SweetAlert
        warning
        title="Mesazh"
        closeOnClickOutside={false}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.error1}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
    
  }

  showMeDogane() {
    const getAlert = () => (
      <SweetAlert
        warning
        title="Mesazh"
        closeOnClickOutside={true}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.error1}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });

    
    setTimeout(() => {
      this.setState({ 
        alert: null, 
        nrKodi:"",
       });
       document.getElementById("nrKodi").focus();
    }, 3000);

    

  }

  showResponse() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Mesazh"
        closeOnClickOutside={false}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.error1}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
  
  }

  OnEnterPress = (e) => {
    if(e.keyCode === 13){
        this.handleClick2(e);
        // this.setState({
        //     nrKodi:""
        // })
    }
  };

  // handleClick2 = (e) => {
  //   e.preventDefault();   
  //   var posts = [...this.state.posts];
  //   const currDate = new Date().toLocaleDateString();
  //   const currTime = new Date().toLocaleTimeString();
   
  //   posts.unshift({
  //     //"nrKodi": this.state.nrKodi,
  //     "nrKodi": this.state.NrPod,
  //     "Data": currDate,
  //     "Ora": currTime,
  //     //"Korrieri": response.ResultMessage,
  //   });

  //   this.setState({ posts: posts, });
  
  //   document.getElementById("nrKodi").style.borderColor = ""; // alert("Form submitted");
   
  //   this.setState({
  //          nrKodi:""
  //  })
        
//};

handleValidation(param) {
  let errors = {};
  let formIsValid = true;
  if (this.state.NrPod.length >= 0 && this.state.NrPod.length < 7) {
    formIsValid = false;
    errors["name"] = "Numri i pod-it nuk eshte i sakte!";
    document.getElementById("nrKodi").style.borderColor = "red";
  } else if (param.includes(this.state.NrPod)) {
    formIsValid = false;
    errors["name"] = "Numri i pod-it eshte shtuar 1 here!";
    document.getElementById("nrKodi").style.borderColor = "red";
  }
  this.setState({ errors: errors });

  return formIsValid;
}

handleClick2 = (e) => {
  e.preventDefault();   
  var posts = [...this.state.posts];
  var posts1 = [...this.state.posts1];
  let errors = {};
  if (this.handleValidation(posts1)) {
    //console.log(this.handleValidation(posts1))
    posts1.push(this.state.nrKodi);
   // posts.push(req);
    this.setState({  posts1: posts1 });
  
    const currDate = new Date().toLocaleDateString();
    const currTime = new Date().toLocaleTimeString();
    const req = {
    PodKodi: this.state.nrKodi,
    AgjensiaBurim: window.UserP.agencyId,
    PerdoruesId: window.UserP.PerdoruesID,
    IdProcesori: window.UserP.idProcesori,
    Token: HmacSHA256(
      Math.round(new Date().getTime() / 1000).toString(),
      window.UserP.key
    ).toString(),
  username: this.state.username,
  };

  axios
      .post(window.UserP.url + "POD/ValidatePickUp", req)
      .then((response) => {
        const searchresults = response.data;
        if (searchresults.Result == true)
        {
          this.setState({
            loading: false,
          });
          posts.unshift({
            //"nrKodi": this.state.nrKodi,
            "nrKodi": this.state.NrPod,
            "Data": currDate,
            "Ora": currTime,
            //"Korrieri": response.ResultMessage,
           });
          this.setState({ posts: posts, });

          if (searchresults.ResultMessage != "")
          {
            this.setState({
              error1: searchresults.ResultMessage,
            });
            //this.showErrors();
            this.showMeDogane();
          }
          //this.showResponse();
        }
        else
        {
          errors["name"] = searchresults.ResultMessage

          this.setState({
            errors:errors
          })

          // this.setState({
          //   loading: false,
          //   error1: searchresults.ResultMessage,
          // });
          // this.showErrors();
        }
          
   
          
        }
      )
      .catch((error) => {
        this.setState({
          loading: false,
          error1: "Ju lutem kontaktoni departamentin e IT!",
        });
        this.showErrors();
      });

  //posts.unshift(response.data);
  this.setState({ posts: posts, });
  console.log(this.state.posts);

  document.getElementById("nrKodi").style.borderColor = ""; // alert("Form submitted");
  } else {
    
  }
  
 
  this.setState({
         nrKodi:""
 })
      
  

};


  handleClick = (e) => {
    this.setState({ loading: true }, () => {
      let postRuaj=[];
    for(let i=0;i<this.state.posts.length;i++){
      postRuaj.push(this.state.posts[i].nrKodi);

    }
      const req = {
        //NrPod: this.state.NrPod,
        //NrPod: this.state.nrKodi,
        NrPod: postRuaj,
        AgjensiaBurim: window.UserP.agencyId,
        PerdoruesId: window.UserP.PerdoruesID,
        IdProcesori: window.UserP.idProcesori,
        Token: HmacSHA256(
          Math.round(new Date().getTime() / 1000).toString(),
          window.UserP.key
        ).toString(),
      username: this.state.username,
      };
  
      axios
        .post(window.UserP.url + "POD/PickUpList", req)
        .then((response) => {
          const searchresults = response.data;
          if (searchresults.Result === true) {
            this.setState({
              loading: false,
              error1: searchresults.ResultMessage,
            });
            this.showResponse();
     
          } else {
            this.setState({
              loading: false,
              error1: searchresults.ResultMessage,
            });

        
            this.showErrors();
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            error1: "Ju lutem kontaktoni departamentin e IT!",
          });
          this.showErrors();
        });
    });
  };

  render() {
    const columns = [
        {
          Header: "Nr",
          accessor: "",
          id: "row",
          maxWidth: 50,
          filterable: false,
          Cell: (row) => {
            return <div>{row.index + 1}</div>;
          },
        },
        {
          Header: "Pod Dergesa",
          //accessor: "NrPod",
          accessor: "nrKodi",
          Cell: "",
          maxWidth: 150,
          filterable: false,
        },
        {
          Header: "Data",
          accessor: "Data",
          Cell: "",
          maxWidth: 150,
          filterable: false,
        },
        {
          Header: "Ora",
          accessor: "Ora",
          Cell: "",
          maxWidth: 150,
          filterable: false,
        },
        {
          Header: "Korrieri",
          accessor: "Korrieri",
          Cell: "",
          maxWidth: 150,
          filterable: false,
        },
        {
          Header: "",
          id: "Fshi",
          accessor: (str) => "Hiq nga Lista",
          maxWidth: 120,
          filterable: false,
  
          Cell: (row) => (
            <span
              style={{
                cursor: "pointer",
                color: "blue",
                textDecoration: "underline",
              }}
              onClick={() => {
                let data = this.state.posts;
                data.splice(row.index, 1);
                this.setState({
                  posts: data,
                  posts1: data,
                  cope: data.length + 1,
                });
              }}
            >
              Hiq nga Lista
            </span>
          ),
        },
      ];
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.state.loading ? (
              <LoadingSpinner />
            ) : (
              <div className="Form">
               
                <div className="card card-body bg-light col-md-6">
        <div className="row">
            <div className="col-md-9">
          <label className="">Nr. POD</label>
          <input
            id="nrKodi"
            name="nrKodi"
            autoFocus
            value={this.state.nrKodi}
            className="form-control "
            type="text"
            onChange={(e) => this.handleInputChange(e, "nrKodi")}
            onKeyUp={this.OnEnterPress}
          />
          <span style={{ color: "red" }}>
                        {this.state.errors["name"]}
                      </span>
          </div>
          <div className="col-md-1 mt-3">
          <button className="btn btn-primary mt-2" onClick={this.handleClick2}>
          <span data-notify="icon" className="pe-7s-angle-left-circle" />
          &nbsp; Shto
        </button>
          </div>
          </div>
                </div>
                <button
                  className="btn btn-primary "
                  onClick={() => this.handleClick()}
                >
                  <span data-notify="icon" className="pe-7s-diskette" />
                  &nbsp; Ruaj
                </button>
                <button className="btn btn-primary ml-4 ">
                  <span data-notify="icon" className="pe-7s-trash" />
                  &nbsp; Pastro
                </button>
                {this.state.alert}
                <div className="row"><p> </p></div>
                <div className="card card-body bg-light col-md-9 mt-4">
                  <ReactTable
                    className="-striped"
                    columns={columns}
                    data={this.state.posts}
                    pivotColumnWidth={2}
                    defaultPageSize={5}
                    
                    pageText="Faqe"
                    nextText="Para"
                    rowsText="Rreshta"
                    previousText="Mbrapa"
                    noDataText="Nuk ka te dhena"
                    maxWidth={150}
                  />
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default PickUpListe;
